import { Button, Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { useDispatch } from "react-redux";
import { GetAllClaimsList, WidthDrownDeleteClaim } from "../config/cliamApi.js";

const SubmitClaimModal = ({
  show,
  onClose,
  claims,
  description,
  status,
  setShowFailedModal,
  setErrorDescription,
  setShowSuccessModal,
  body,
  setPage,
  setRowsPerPage,
}) => {
  const dispatch = useDispatch();

  const submitClaims = async () => {
    const requestBody = {
      claim_data: claims?.map((claim) => ({
        claimid: claim.claimfull_id,
        claim_type: claim.claim_type,
        claim_status: status,
      })),
    };

    const response = await dispatch(
      WidthDrownDeleteClaim(requestBody)
    ).unwrap();

    if (response?.success) {
      setShowSuccessModal(true);
      setShowFailedModal(false);
      setErrorDescription(null);
      onClose();
      setPage(0);
      setRowsPerPage(10);
      await dispatch(GetAllClaimsList(body)).unwrap();
    } else {
      setErrorDescription(response?.message_en);
      setShowFailedModal(true);
      onClose();
    }
  };

  return (
    <>
      <Modal show={show} centered dialogClassName="wizard-modal">
        <Modal.Body>
          <FalconCloseButton
            onClick={onClose}
            size="sm"
            className="position-absolute top-0 end-0 me-2 mt-2"
          />
          <Flex direction="column" alignItems="center" className="mb-3">
            <h6 className="fs-8 text-capitalize text-800">
              {status === "withdrawn"
                ? "withdraw"
                : status === "unwithdrawn"
                ? "unwithdraw"
                : status}{" "}
              Claim(s)
            </h6>
            <h6 className="text-center text-700">{description}</h6>
            <h6 className="fs-10 text-600 text-center">
              Are you sure you want to{" "}
              {status === "withdrawn"
                ? "withdraw"
                : status === "unwithdrawn"
                ? "unwithdraw"
                : status}{" "}
              <span className="text-danger">{claims?.length}</span> claim(s)?
            </h6>
          </Flex>

          <hr />
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button variant="danger" size="sm" onClick={onClose}>
              No
            </Button>
            <Button variant="success" size="sm" onClick={submitClaims}>
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SubmitClaimModal;
